module.exports = __webpack_public_path__ + "assets/img/22_243_big.bd03b29b.jpg";